import { DOMNode } from "html-react-parser"
import IframeResizer from "iframe-resizer-react"
import React, { useRef, useState } from "react"
import classNames from "../utils/classnames"
import Loading from "./loading"

interface IIframeGravityFormProps {
  domNode: DOMNode
}

export default function IframeGravityForm({
  domNode,
}: IIframeGravityFormProps): JSX.Element {
  // console.log(`IframeGravityForm`, domNode)
  const formId = domNode?.attribs?.id.replace(`gform_wrapper_`, ``)
  // random cache bypass string
  const [loadingForm, setLoadingForm] = useState(true)
  const iframeRef = useRef(null)

  const onMessage = data => {
    // console.log(`onMessage`, data)
    if (data.message === `ready`) {
      setLoadingForm(false)
    }
  }
  return (
    <>
      {loadingForm && <Loading message="Loading form" />}
      <div
        className={classNames(`flex flex-col gap-2`, { hidden: !loadingForm })}
      >
        <IframeResizer
          forwardRef={iframeRef}
          heightCalculationMethod="lowestElement"
          inPageLinks
          // log
          onMessage={onMessage}
          src={`https://content.georgiancollege.ca/embedform?form_id=${formId}`}
          style={{ width: `1px`, minWidth: `100%` }}
        />
      </div>
    </>
  )
}
